export default {
  title: 'Brändin synkronointi — Brändit',
  subtitle:
    'Yleiskatsaus kaikista ryhmän ravintoloista ja niiden synkronoiduista ominaisuuksista. Vain tilin ylläpitäjä voi tehdä muutoksia.',
  alert: {
    message: 'Vain ylläpitäjän käyttöoikeus',
    description:
      'Vain tilin ylläpitäjä voi tehdä muutoksia pääruokalistaan, hinnoitteluun ja tarjouksiin. Kaikki toimipisteet saavat päivitykset automaattisesti.',
  },
  locations: {
    title: 'Toimipisteet',
    description: 'Kaikki ryhmän ravintolat, jotka jakavat pääruokalistan ja asetukset',
    locations_zero: '0 toimipistettä',
    locations_one: '1 toimipiste',
    locations_other: '{{count}} toimipistettä',
    synced: 'Synkronoitu',
  },
  features: {
    title: 'Synkronoidut ominaisuudet',
    description: 'Näitä ominaisuuksia hallitaan pääasetuksilla',
    menus: {
      title: 'Pääruokalista',
      desription: 'Ruokalistan tuotteet, kategoriat ja kuvaukset synkronoidaan kaikkiin toimipisteisiin',
    },
    smart_pricing: {
      title: 'Älykäs hinnoittelu',
      desription: 'Hinnoittelusäännöt ja muutokset synkronoidaan kaikkiin toimipisteisiin',
    },
    offers: {
      title: 'Tarjoukset ja kampanjat',
      desription: 'Aktiiviset tarjoukset, alennukset ja kampanjat synkronoidaan kaikkiin toimipisteisiin',
    },
  },
};
